<template>
  <div style="padding:10px">
    <el-form ref="saveForm1" size="mini" class="bj-query-form bj-query-form-for-cal-height">
      <el-row :gutter="20" style="padding: 10px 10px;">
        <el-col :span="colSpan*4/6">
            <div><span style="font-weight:bolder;">{{ $t('billingPage.IRPallet') }}</span>：<span style="font-weight:bolder;color: darkslateblue">{{ dataInfo.summary.palletQty || 0 }}</span></div>
        </el-col>
      </el-row>
    </el-form>

    <el-form ref="saveForm1" size="mini" class="bj-query-form bj-query-form-for-cal-height">
      <el-row :gutter="20" style="padding: 0 10px;">
        <el-col :span="colSpan">
            <LineChart :chart-data="lineChartDataLine1" height="350px" />
        </el-col>
        <el-col :span="colSpan">
            <LineChart :chart-data="lineChartDataLine2" height="350px" />
        </el-col>
        <el-col :span="colSpan">
            <LineChart :chart-data="lineChartDataLine3" height="350px" />
        </el-col>
        <el-col :span="colSpan">
            <LineChart :chart-data="lineChartDataLine4" height="350px" />
        </el-col>
      </el-row>
    </el-form>

    <el-form ref="saveForm1" size="mini" class="bj-query-form bj-query-form-for-cal-height" style="padding-top:50px;">
      <div style="padding-bottom: 20px;"><b>{{ $t('billingPage.IRTIP') }}: ${{ dataInfo.totalIncome }}</b></div>
      <el-row :gutter="20" style="padding: 0 10px;">
        <el-col :span="colSpan*2">
          <LineChart :chart-data="lineChartDataBar1" />
        </el-col>
        <el-col :span="colSpan*2">
          <LineChart :chart-data="lineChartDataPie1" />
        </el-col>
      </el-row>
    </el-form>

    <el-form ref="saveForm1" size="mini" class="bj-query-form bj-query-form-for-cal-height" style="padding-top:50px;">
      <div style="padding-bottom: 20px;"><b>{{ $t('billingPage.IRTCP') }}: ${{ dataInfo.totalCost }}</b></div>
      <el-row :gutter="20" style="padding: 0 10px;">
        <el-col :span="colSpan*2">
          <LineChart :chart-data="lineChartDataBar2" />
        </el-col>
        <el-col :span="colSpan*2">
          <LineChart :chart-data="lineChartDataPie2" />
        </el-col>
      </el-row>
    </el-form>

    <el-form ref="saveForm1" size="mini" class="bj-query-form bj-query-form-for-cal-height" style="padding-top:50px;">
      <div style="padding-bottom: 20px;"><b>{{ $t('billingPage.IRTGPP') }}: ${{ dataInfo.totalGrossProfit }}</b></div>
      <el-row :gutter="20" style="padding: 0 10px;">
        <el-col :span="colSpan*2">
          <LineChart :chart-data="lineChartDataBar3" />
        </el-col>
        <el-col :span="colSpan*2">
          <LineChart :chart-data="lineChartDataPie3" />
        </el-col>
      </el-row>
    </el-form>

    <el-form ref="saveForm1" size="mini" class="bj-query-form bj-query-form-for-cal-height" style="padding-top:50px;">
      <div style="padding-bottom: 20px;"><b>{{ $t('billingPage.IRTPMP') }} : ${{ dataInfo.totalProfitMargin }}</b></div>
      <el-row :gutter="20" style="padding: 0 10px;">
        <el-col :span="colSpan*2">
          <LineChart :chart-data="lineChartDataBar4" />
        </el-col>
        <el-col :span="colSpan*2">
          <LineChart :chart-data="lineChartDataPie4" />
        </el-col>
      </el-row>
    </el-form>

  </div>
</template>
<script>
import LineChart from '../echartsForm/LineChart';
import { billApi } from '@/api';

export default {
name: 'BillingPageInvoiceReportTotal',
components: { LineChart },
props: {
    chartData: {
      type: Object,
      default: null,
    }
},
data() {
  return {
    colSpan: 6,
    dataInfo: {
      summary: {}
    },
    lineChartDataLine1: {},
    lineChartDataLine2: {},
    lineChartDataLine3: {},
    lineChartDataLine4: {},
    lineChartDataBar1: {},
    lineChartDataBar2: {},
    lineChartDataBar3: {},
    lineChartDataBar4: {},
    lineChartDataPie1: {},
    lineChartDataPie2: {},
    lineChartDataPie3: {},
    lineChartDataPie4: {},
  };
},
methods: {
  init(params) {
    billApi.getInvoiceReportPallet(params).then(res => {
      res.data.data.summary = res.data.data.summary || {};
      this.dataInfo = res.data.data;
      const lineChartDataLine1 = JSON.parse(JSON.stringify(this.chartData.lineChartDataLine));
      lineChartDataLine1.xAxis.data = res.data.data.weeklyTotalIncome?.map(item => item.itemName);
      lineChartDataLine1.series[0].data = res.data.data.weeklyTotalIncome?.map(item => item.itemValue);
      lineChartDataLine1.series[0].name = this.$t('billingPage.IRWTIP');
      this.lineChartDataLine1 = lineChartDataLine1;

      const lineChartDataLine2 = JSON.parse(JSON.stringify(this.chartData.lineChartDataLine));
      lineChartDataLine2.xAxis.data = res.data.data.weeklyTotalCost?.map(item => item.itemName);
      lineChartDataLine2.series[0].data = res.data.data.weeklyTotalCost?.map(item => item.itemValue);
      lineChartDataLine2.series[0].name = this.$t('billingPage.IRWTCP');
      this.lineChartDataLine2 = lineChartDataLine2;

      const lineChartDataLine3 = JSON.parse(JSON.stringify(this.chartData.lineChartDataLine));
      lineChartDataLine3.xAxis.data = res.data.data.weeklyTotalGrossProfit?.map(item => item.itemName);
      lineChartDataLine3.series[0].data = res.data.data.weeklyTotalGrossProfit?.map(item => item.itemValue);
      lineChartDataLine3.series[0].name = this.$t('billingPage.IRWTGPP');
      this.lineChartDataLine3 = lineChartDataLine3;

      const lineChartDataLine4 = JSON.parse(JSON.stringify(this.chartData.lineChartDataLine));
      lineChartDataLine4.xAxis.data = res.data.data.weeklyTotalProfitMargin?.map(item => item.itemName);
      lineChartDataLine4.series[0].data = res.data.data.weeklyTotalProfitMargin?.map(item => item.itemValue);
      lineChartDataLine4.series[0].name = this.$t('billingPage.IRWTPMP');
      this.lineChartDataLine4 = lineChartDataLine4;

      // 柱状图
      const lineChartDataBar1 = JSON.parse(JSON.stringify(this.chartData.lineChartDataBar));
      lineChartDataBar1.xAxis = {
          data: res.data.data.totalIncomeItems?.map(item => item.itemName),
          axisLabel: {
            interval: 0, rotate: 30,
            formatter: function (value, index) {
                var item = res.data.data.totalIncomeItems[index];
                return value + '\n' + item.itemValue; // 返回数据名 + 换行的数据值
            }
          }
        };
      lineChartDataBar1.series[0].data = res.data.data.totalIncomeItems?.map(item => item.itemValue);
      this.lineChartDataBar1 = lineChartDataBar1;

      const lineChartDataBar2 = JSON.parse(JSON.stringify(this.chartData.lineChartDataBar));
      lineChartDataBar2.xAxis = {
        data: res.data.data.totalCostItems?.map(item => item.itemName),
        axisLabel: {
          interval: 0, rotate: 30,
          formatter: function (value, index) {
              var item = res.data.data.totalCostItems[index];
              return value + '\n' + item.itemValue; // 返回数据名 + 换行的数据值
          }
        }
      };
      lineChartDataBar2.series[0].data = res.data.data.totalCostItems?.map(item => item.itemValue);
      this.lineChartDataBar2 = lineChartDataBar2;

      const lineChartDataBar3 = JSON.parse(JSON.stringify(this.chartData.lineChartDataBar));
      lineChartDataBar3.xAxis = {
        data: res.data.data.totalGrossProfitItems?.map(item => item.itemName),
        axisLabel: {
          interval: 0, rotate: 30,
          formatter: function (value, index) {
              var item = res.data.data.totalGrossProfitItems[index];
              return value + '\n' + item.itemValue; // 返回数据名 + 换行的数据值
          }
        }
      };
      lineChartDataBar3.series[0].data = res.data.data.totalGrossProfitItems?.map(item => item.itemValue);
      this.lineChartDataBar3 = lineChartDataBar3;

      const lineChartDataBar4 = JSON.parse(JSON.stringify(this.chartData.lineChartDataBar));
      lineChartDataBar4.xAxis = {
        data: res.data.data.totalProfitMarginItems?.map(item => item.itemName),
        axisLabel: {
          interval: 0, rotate: 30,
          formatter: function (value, index) {
              var item = res.data.data.totalProfitMarginItems[index];
              return value + '\n' + item.itemValue; // 返回数据名 + 换行的数据值
          }
        }
      };
      lineChartDataBar4.series[0].data = res.data.data.totalProfitMarginItems?.map(item => item.itemValue);
      this.lineChartDataBar4 = lineChartDataBar4;

      // 饼图
      const lineChartDataPie1 = JSON.parse(JSON.stringify(this.chartData.lineChartDataPie));
      lineChartDataPie1.series[0].data = res.data.data.totalIncomeItems?.map(item => {
        return { value: item.itemValue, name: item.itemName };
      });
      this.lineChartDataPie1 = lineChartDataPie1;

      const lineChartDataPie2 = JSON.parse(JSON.stringify(this.chartData.lineChartDataPie));
      lineChartDataPie2.series[0].data = res.data.data.totalCostItems?.map(item => {
        return { value: item.itemValue, name: item.itemName };
      });
      this.lineChartDataPie2 = lineChartDataPie2;

      const lineChartDataPie3 = JSON.parse(JSON.stringify(this.chartData.lineChartDataPie));
      lineChartDataPie3.series[0].data = res.data.data.totalGrossProfitItems?.map(item => {
        return { value: item.itemValue, name: item.itemName };
      });
      this.lineChartDataPie3 = lineChartDataPie3;

      const lineChartDataPie4 = JSON.parse(JSON.stringify(this.chartData.lineChartDataPie));
      lineChartDataPie4.series[0].data = res.data.data.totalProfitMarginItems?.map(item => {
        return { value: item.itemValue, name: item.itemName };
      });
      this.lineChartDataPie4 = lineChartDataPie4;
    });
  }
}
};
</script>
